const base = "api.antikalmas.com"
export const baseUrl = `https://${base}`;
